import { render, staticRenderFns } from "./PersonGroupIcon.vue?vue&type=template&id=24af64cc&"
import script from "./PersonGroupIcon.vue?vue&type=script&lang=ts&"
export * from "./PersonGroupIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports